/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "service": {
            "nested": {
              "v1": {
                "nested": {
                  "DebitCardData": {
                    "fields": {
                      "token": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "cardState": {
                        "type": "squareup.bbfrontend.service.v1.DebitCardData.CardState",
                        "id": 2,
                        "rule": "optional"
                      },
                      "panLastFour": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "nameOnCard": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "cardType": {
                        "type": "squareup.bbfrontend.service.v1.DebitCardData.CardType",
                        "id": 5,
                        "rule": "optional"
                      },
                      "isActivatable": {
                        "type": "bool",
                        "id": 6,
                        "rule": "optional"
                      },
                      "cardBrand": {
                        "type": "squareup.bbfrontend.service.v1.DebitCardData.CardBrand",
                        "id": 7,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "CardState": {
                        "values": {
                          "UNKNOWN": 0,
                          "ACTIVE": 1,
                          "DISABLED": 2,
                          "ACTIVE_PENDING_2FA": 3,
                          "SHIPPED": 4,
                          "ISSUED": 5,
                          "SUSPENDED": 6,
                          "TERMINATED": 7
                        }
                      },
                      "CardType": {
                        "values": {
                          "DO_NOT_USE_CARD_TYPE": 0,
                          "PHYSICAL": 1,
                          "VIRTUAL": 2,
                          "PAIR": 3
                        }
                      },
                      "CardBrand": {
                        "values": {
                          "DO_NOT_USE_CARD_BRAND": 0,
                          "VISA": 1,
                          "MASTERCARD": 2
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.DebitCardData && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.DebitCardData?.nested?.CardState && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.DebitCardData?.nested?.CardType && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.DebitCardData?.nested?.CardBrand) {
  $root.addJSON(jsonData);
}

/**
 * A simplified map for Bizbank.CardData that's tailored to client use.
 *
 * SOURCE DebitCardData @ squareup/bbfrontend/v1/debit_card_data.proto at 14:1
 */
export const DebitCardData = $root.lookupType('squareup.bbfrontend.service.v1.DebitCardData');
fixType(DebitCardData, {
  token: {
    notEmpty: true
  },
  cardState: {
    required: true
  },
  panLastFour: {
    notEmpty: true
  },
  nameOnCard: {
    notEmpty: true
  },
  isActivatable: {
    required: true
  },
  cardBrand: {
    required: true
  }
});
Builder.createAndAttachToType(DebitCardData);
/**
 * These card states are simplified mappings for clients and not meant to replicate the full set
 * of states found in bizbank.service.CardData.CardState. Clients do not have unique experiences
 * for all possible card states so bb-frontend pairs down the possibilities for
 * clearer management configuration.
 *
 * SOURCE CardState @ squareup/bbfrontend/v1/debit_card_data.proto at 34:3
 */
DebitCardData.CardState = $root.lookupEnum('squareup.bbfrontend.service.v1.DebitCardData.CardState').values;
/**
 * SOURCE CardType @ squareup/bbfrontend/v1/debit_card_data.proto at 45:3
 */
DebitCardData.CardType = $root.lookupEnum('squareup.bbfrontend.service.v1.DebitCardData.CardType').values;
/**
 * SOURCE CardBrand @ squareup/bbfrontend/v1/debit_card_data.proto at 52:3
 */
DebitCardData.CardBrand = $root.lookupEnum('squareup.bbfrontend.service.v1.DebitCardData.CardBrand').values;